<template>
  <div class="generated-image-block">
    <div class="block-container">
      <BaseImage
        alt="image"
        class="generated-image"
        v-for="image in data.images"
        :key="image.id"
        :src="image.url"
        @click="openViewerImage(image)"
      />
    </div>
    <BbPopup v-model="showPreviewModal" width="800px">
      <UserImagePreview
        :image-id="selectedImage.id"
        :in-conversation-context="true"
        :prompt="isUserMessage ? currentMessage.message : selectedImage.userQuery"
        @close="showPreviewModal = false"
        @download="onDownload(selectedImage)"
        @remix="(image) => onRemix(image)"
      />
    </BbPopup>
  </div>
</template>
<script>
import { computed, onMounted, ref } from 'vue';
import { useStore } from 'vuex';

import { SetQueryValue } from '~/constants/mutations';
import { Role } from '~/constants/conversationModels';

import useImageGeneration from '~/composables/useImageGeneration';
import useConversations from '~/composables/useConversations';
import BaseImage from '~/components/common/BaseImage.vue';
import UserImagePreview from '~/components/userImages/UserImagePreview.vue';

export default {
  components: { UserImagePreview, BaseImage },
  props: {
    messageId: {
      type: String,
    },
    data: {
      type: Object,
      default: () => {},
    },
    type: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    images: {
      type: Array,
      default: () => [],
    },
  },

  setup(props) {
    const store = useStore();
    const { updateGeneratedImagesData, setUserImageForRemix, downloadUserImage } = useImageGeneration();
    const { currentConversation } = useConversations();

    const showPreviewModal = ref(false);
    const selectedImage = ref(null);

    const currentMessage = computed(() =>
      currentConversation.value.messages?.find((msg) => msg.messageId === props.messageId),
    );
    const isUserMessage = computed(() => currentMessage.value.role === Role.user);

    const onRemix = async (image) => {
      const userRemixObject = {
        query: image.userQuery,
        remixImage: image.url,
        remixImageId: image.id,
      };
      setUserImageForRemix({ ...image, ...userRemixObject });
      store.dispatch(`conversationStore/${SetQueryValue}`, userRemixObject);
      showPreviewModal.value = false;
    };

    const onDownload = async (selectedImage) => {
      const title = selectedImage.name || 'Generetad_Image.png';
      const userConversationId = currentConversation?.value?.userId || '';
      await downloadUserImage(selectedImage.id, title, userConversationId);
    };

    const openViewerImage = (image) => {
      showPreviewModal.value = true;
      selectedImage.value = image;
    };

    onMounted(async () => {
      // get images from s3 bucket
      const userConversationId = currentConversation?.value?.userId || '';
      await updateGeneratedImagesData(props.messageId, props.data, userConversationId);
    });

    return {
      openViewerImage,
      selectedImage,
      showPreviewModal,
      onDownload,
      onRemix,
      isUserMessage,
      currentMessage,
    };
  },
};
</script>

<style scoped lang="scss">
.block-container {
  display: flex;
  flex-direction: row;
  gap: $bb-spacing-2;

  .generated-image {
    width: 100px;
    height: 100px;

    :deep(img) {
      max-height: 200px !important;
    }
  }
}
</style>
